import { queryString as qs } from './window'

const { a_aid: affiliateId, app: isApp } = qs

function getInfluencerFromPath(relativePath) {
  const matches = /\/partners\/([a-zA-Z0-9]*)/.exec(relativePath)
  if (matches && matches.length > 0) {
    const [, partnerId] = matches
    return partnerId
  }
  return null
}

function getPartnerId(partner) {
  let partnerId = partner.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
  let regex = new RegExp('[\\?&]' + partnerId + '=([^&#]*)')
  let results = regex.exec(location.search)
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
  // if (
  //   undefined !== document.getElementsByClassName('nm-embed') &&
  //   undefined !== document.getElementsByClassName('nm-embed')[0] &&
  //   undefined !== document.getElementsByClassName('nm-embed')[0].getAttribute('data-partner')
  // ) {
  //   return document.getElementsByClassName('nm-embed')[0].getAttribute('data-partner')
  // }
  // return 'partner id is missing'
}

export function getInfluencerId() {
  return getInfluencerFromPath(window.location.pathname) || affiliateId
}

export function getUserPlatform() {
  return IsMobileApp()
    ? 'native'
    : /mobile|android|ipad|iphone/i.exec(navigator.userAgent) === null ? 'desktop' : 'mobile'
}

export function IsMobileApp() {
  return isApp === '1'
}

export function getSyndicationPartnerId() {
  return getPartnerId('partner')
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/utils/pageContext.js